// extracted by mini-css-extract-plugin
module.exports = {"root":"_c8362792","control":"_034f4878","label":"_95da6232"};